import React from "react";
import "./priceTracker/main.css";
import Coin from "./priceTracker/Coin";

function App() {
  return (
    <div className="App">
      <Coin />
    </div>
  );
}

export default App;
